import React, { useEffect, useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

function PowerOfficials() {
  const { id: power_id, plantName } = useParams(); // Power Plant ID from route
  const [officials, setOfficials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all officials for this power plant
 

const fetchOfficials = useCallback(async () => {
  try {
    const res = await axios.get(`https://backend-zkgn.onrender.com/api/powergen_officials/plant/${power_id}`);
    setOfficials(res.data);
  } catch (error) {
    console.error("Error fetching officials:", error.message);
  } finally {
    setLoading(false);
  }
}, [power_id]);

useEffect(() => {
  fetchOfficials();
}, [fetchOfficials]);


  // Delete official
  const handleDelete = async (genofficial_id) => {
    if (!window.confirm("Are you sure you want to delete this official?")) return;

    try {
      await axios.delete(`https://backend-zkgn.onrender.com/api/powergen_officials/delete/${genofficial_id}`);
      // Remove from state
      setOfficials(prev => prev.filter(off => off.genofficial_id !== genofficial_id));
    } catch (error) {
      console.error("Delete failed:", error.message);
      alert("Failed to delete official. Check console for details.");
    }
  };

  if (loading) return <div className="text-center my-5">Loading officials...</div>;

  return (
    <div className="container-fluid my-5">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h4 className="fw-bold text-tertiary mb-2">{officials.length} Officials Found</h4>
        <Link to={`/add-powergen-official/${plantName}/${power_id}`} className="btn btn-primary">
          Add Power Plant Official
        </Link>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered officials-table">
          <thead className="table-light">
            <tr>
              <th>Designation</th>
              <th>Official's Name</th>
              <th>Official's Email</th>
              <th>Phone Number</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {officials.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center">No officials found.</td>
              </tr>
            )}
            {officials.map(official => (
              <tr key={official.genofficial_id}>
                <td>{official.genofficial_designation}</td>
                <td>{official.genofficial_name}</td>
                <td>{official.genofficial_email || "-"}</td>
                <td>{official.genofficial_phone || "-"}</td>
                <td className="text-center">
                  <Link
                    to={`/edit-powergen-official/${plantName}/${official.genofficial_id}/${power_id}`}
                    className="btn btn-link text-success me-2 p-0"
                  >
                    <i className="fa fa-edit"></i>
                  </Link>
                  <button
                    className="btn btn-link text-danger p-0"
                    onClick={() => handleDelete(official.genofficial_id)}
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PowerOfficials;
